// extracted by mini-css-extract-plugin
export var articleFooter = "article-footer-module--articleFooter--jX2jj";
export var articleFooterH4 = "article-footer-module--articleFooterH4--Xn7qH";
export var opinionButton = "article-footer-module--opinionButton--BwI6z";